// extracted by mini-css-extract-plugin
export default {"volume":"Volume_volume","off":"Volume_off"};